import { Table  } from 'reactstrap'

export default function ActionsTable(props) {
  console.log('ActionsTable rendered: ', props)
  const { actionHistory } = props

  const rows = []
  for (let row of actionHistory) {
    rows.push(
      <tr key={row.documentTypeName}>
        <td>{row.documentTypeName}</td>
        <td>{row.actionTypeName}</td>
        <td style={{ textAlign: 'right' }}>{row.count}</td>
      </tr>
    )
  }
  return (
    <Table bordered size="sm" style={{ width: 'auto' }}>
      <thead>
        <tr>
          <th>Object Type</th>
          <th>Action Type</th>
          <th>Count</th>
        </tr>
      </thead>
      <tbody>
        {rows}
      </tbody>
    </Table>
  )
}
